import React from 'react'
import { NavLink } from 'react-router-dom'

const Navbar = () => {
    return (
        
            <nav className="w3-sidebar w3-collapse w3-white w3-animate-left " id="mySidebar" style={{zIndex:'3', width:'250px'}}><br/>
                <div className=" w3-container w3-cell-row my-user" >
                    <div className="w3-cell w3-cell-middle">
                        <span className="w3-text-grey"><i class="fa fa-university w3-xxlarge"></i></span>
                    </div>
                    <div className="w3-cell w3-cell-middle">
                        <span className="w3-tiny w3-text-green"><b>IITR Project:</b></span><br/>
                    <span><strong>Hybrid Microgrid</strong></span>
                    </div>
                </div>

                <div className="w3-bar-block w3-text-grey">
         
                    <NavLink to="/summary" className="w3-bar-item w3-button w3-padding"><i className="fa fa-eye fa-fw"></i>  Summary</NavLink>
                    <NavLink to="/projectpartner" className="w3-bar-item w3-button w3-padding "><i className="fa fa-bank fa-fw"></i>  Project Partner</NavLink>
                    <NavLink to="/patentpublication" className="w3-bar-item w3-button w3-padding"><i className="fa fa-users fa-fw"></i>  Patent & Publications</NavLink>
                    <NavLink to="/roadmap" className="w3-bar-item w3-button w3-padding"><i className="fa fa-users fa-fw"></i>  RoadMap</NavLink>
                    <NavLink to="/investigators" className="w3-bar-item w3-button w3-padding"><i className="fa fa-diamond fa-fw"></i>  Investigators</NavLink>
                    <NavLink to="/scholars" className="w3-bar-item w3-button w3-padding"><i className="fa fa-diamond fa-fw"></i>  Scholars</NavLink>
                    <NavLink to="/trainedmanpower" className="w3-bar-item w3-button w3-padding"><i className="fa fa-diamond fa-fw"></i>  Trained Manpower</NavLink>
                    <NavLink to="/labsetup" className="w3-bar-item w3-button w3-padding"><i className="fa fa-diamond fa-fw"></i>  Lab Setup</NavLink>
                    <NavLink to="/fielddemonstration" className="w3-bar-item w3-button w3-padding"><i className="fa fa-diamond fa-fw"></i>  Field Demostration</NavLink>
                    <NavLink to="/gallery" className="w3-bar-item w3-button w3-padding"><i className="fa fa-bell fa-fw"></i> Gallery </NavLink>
                </div>
            </nav>
        
    )
}

export default Navbar



